<template>
  <div class="stepper-box">
      <div class="stepper-content">
          <van-stepper
          v-model="defaultTxt"
           input-width="180px"
           :step="step"
           :max="max"
           :min="min"
           @change="change"
           :integer="true"
            button-size="50px" />
      </div>
    <span class="suffix">{{suffix}}</span>
  </div>
</template>

<script>

export default {
  data() {
    return {
      defaultTxt: 0,
      suffix:"元",
      max:10000000,
      min:0,
      step:1000,
      timor:null,
    };
  },
  props: ["stepNum","selectData","parentItem","type"],
  mounted() {
      this.defaultTxt=_.get(this.selectData,"elementValue",0);
      this.suffix=_.get(this.selectData,"suffix","元");
      this.max=_.get(this.selectData,"max",10000000);
      this.min=_.get(this.selectData,"min",0);
      this.step=_.get(this.selectData,"step",1000);
  },
  methods: {
    change(e){
        let self=this;
        if(this.timor)clearTimeout(this.timor);
        this.timor=setTimeout(()=>{
            console.log(e);
            let integer=e/self.step;
            if(Number.isInteger(integer)){
                self.getResult()
            }else{
                self.$notice.alert(`您填写的数字需要是${self.step}的整数倍！`);
                self.defaultTxt=self.selectData.elementValue
            }
        },500)
    },

    getResult() {
      //选择后回调到父组件
      let value = this.defaultTxt;
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    },

  },
  watch: {
      selectData(newVal) {
        this.defaultTxt = newVal.elementValue;
        this.max=_.get(this.selectData,"max",10000000);
        this.min=_.get(this.selectData,"min",0);
        this.step=_.get(this.selectData,"step",1000);
      }
    }
};
</script>

<style lang="scss">
.stepper-box{
    width: 100%;
    .stepper-content{
        width: 78%;
        display: inline-block;
        float: left;
    }
    input.van-stepper__input{
        background-color: #fff;
        border-top: 1px solid #f2f3f5;
        border-bottom: 1px solid #f2f3f5;
        font-size: 24px;
    }
    .suffix{
        display: inline-block;
        font-size: 20px;
        color: #666;
        line-height: 60px;
        float: left;
    }
}

</style>
